import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import FindOurSchool from './pages/FindOurSchool';
import ScheduleTour from './pages/ScheduleTour';
import ContactUs from './pages/ContactUs';
import Curriculum from './pages/Curriculum';
import About from './pages/About';
import Resources from './pages/Resources';
import Blog from './pages/Blog';
import Forms from './pages/Forms';
import AdminDashboard from './pages/AdminDashboard';
import './styles/App.css';

// Configure Amplify with CDK output values
const amplifyConfig = {
  Auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_OssahFMiy',
    userPoolWebClientId: '6pl42a7pp2p8mt9l3q6s1fhhf4'
  },
  API: {
    endpoints: [
      {
        name: 'api',
        endpoint: 'https://ji8nuitvzg.execute-api.us-east-1.amazonaws.com/prod'
      }
    ]
  }
};

Amplify.configure(amplifyConfig);

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/find-our-school" element={<FindOurSchool />} />
            <Route path="/schedule-tour" element={<ScheduleTour />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/curriculum" element={<Curriculum />} />
            <Route path="/about" element={<About />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/forms" element={<Forms />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;